export const navData = [
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100",
    text: "Top Offers",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100",
    text: "Grocery",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100",
    text: "Mobile",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/82b3ca5fb2301045.png?q=100",
    text: "Fashion",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/69c6589653afdb9a.png?q=100",
    text: "Electronics",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/ee162bad964c46ae.png?q=100",
    text: "Home",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100",
    text: "Appliances",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/71050627a56b4693.png?q=100",
    text: "Travel",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100",
    text: "Beauty, Toys & More",
  },
];

export const bannerData = [
  "https://rukminim1.flixcart.com/flap/3376/560/image/d117a62eb5fbb8e1.jpg?q=50",
  "https://rukminim1.flixcart.com/flap/3376/560/image/57267a180af306fe.jpg?q=50",
  "https://rukminim1.flixcart.com/flap/3376/560/image/ae9966569097a8b7.jpg?q=50",
  "https://rukminim1.flixcart.com/flap/3376/560/image/f6202f13b6f89b03.jpg?q=50",
];

export const dealData = [
  {
    id: "product1",
    url: "https://rukminim1.flixcart.com/image/200/200/khf63680/cases-covers/back-cover/d/7/g/spigen-acs02256-original-imafxfgbffqaugur.jpeg?q=70",
    detailUrl: "",
    title: {
      shortTitle: "Mobile Covers",
    },
    discount: "Extra 10% Off",
    tagline: "Deal of the day",
  },
  {
    id: "product2",
    url: "https://rukminim1.flixcart.com/image/200/200/k5lcvbk0/moisturizer-cream/9/w/g/600-body-lotion-aloe-hydration-for-normal-skin-nivea-lotion-original-imafz8jb3ftt8gf9.jpeg?q=70",
    title: {
      shortTitle: "Skin & Hair Care",
    },
    discount: "From 99+5% Off",
    tagline: "Shampoos, Face Washes & More",
  },
  {
    id: "product3",
    url: "https://rukminim1.flixcart.com/flap/200/200/image/74bc985c62f19245.jpeg?q=70",
    title: {
      shortTitle: "Skybags & Safari",
    },
    discount: "Upto 70% Off",
    tagline: "Deal of the Day",
  },
  {
    id: "product4",
    url: "https://rukminim1.flixcart.com/image/300/300/kll7bm80/smartwatch/c/1/n/43-mo-sw-sense-500-android-ios-molife-original-imagyzyycnpujyjh.jpeg?q=70",
    detailUrl:
      "https://rukminim1.flixcart.com/image/416/416/kll7bm80/smartwatch/c/1/n/43-mo-sw-sense-500-android-ios-molife-original-imagyzyycnpujyjh.jpeg?q=70",
    title: {
      shortTitle: "Smart Watches",
      longTitle: "Molife Sense 500 Smartwatch  (Black Strap, Freesize)",
    },
    price: {
      mrp: 6999,
      cost: 4049,
      discount: "42%",
    },
    description:
      "The Molife Sense 500, a brilliant smartwatch with a beautiful large display. Say hello to the infinity 1.7-inch display with 2.5D curved edges. Thanks to seamless Bluetooth 5.0 connectivity, you wont have to keep waiting. Bring a change to your outfit every day with changeable straps. A splash of color every day keeps the boredom away.",
    discount: "Grab Now",
    tagline: "Best Seller",
  },
  {
    id: "product5",
    url: "https://rukminim1.flixcart.com/flap/150/150/image/b616a7aa607d3be0.jpg?q=70",
    title: {
      shortTitle: "Sports & Fitness Essentials",
    },
    discount: "Upto 80% Off",
    tagline: "Ab Exerciser, Yoga & more",
  },
];

export const furnitureData = [
  {
    url: "https://rukminim1.flixcart.com/image/300/300/ke7ff680/hammock-swing/j/f/u/q3-jkaf-y3l0-furniture-kart-original-imafux96kpy7grch.jpeg?q=70",
    title: {
      shortTitle: "Hammock And Swings",
    },
    discount: "From ₹199",
    tagline: "Trendy Collection",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/bean-bag/h/v/b/f8-the-furniture-store-xxxl-original-imae65d3wg7qzpkn.jpeg?q=70",
    title: {
      shortTitle: "Bean Bag Covers",
    },
    discount: "Min 80% Off",
    tagline: "XL, XXL & More",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/jlcmavk0/aquarium-tank/s/4/5/usb-desktop-aquarium-with-running-water-calendar-temperature-and-original-imaf8hv4nkv55gx8.jpeg?q=70",
    title: {
      shortTitle: "Aquarium Tank",
    },
    discount: "From ₹299",
    tagline: "Flat, Round, Cube & More",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/jffpoy80/office-study-chair/v/v/z/pp-am-5001cb-apex-original-imaf3u8rbr5cdycv.jpeg?q=70",
    title: {
      shortTitle: "Office & Study Chairs",
    },
    discount: "Min 50% Off",
    tagline: "Fabric & Leatherette",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/jvcp9jk0/recliner/z/w/x/brown-top-grain-leather-sf7018011-1-royaloak-original-imafg9s9hh9vzpf3.jpeg?q=70",
    title: {
      shortTitle: "Recliner",
    },
    discount: "From ₹4999",
    tagline: "Bantia, RoyalOak & More",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/jlqwpe80-1/tv-entertainment-unit/d/t/f/particle-board-holland-tv-unit-black-forzza-black-original-imaf8t5ybywcdtys.jpeg?q=70",
    title: {
      shortTitle: "Tv Units",
    },
    discount: "From ₹2100",
    tagline: "Forzza, Zuari & more",
  },
  {
    url: "https://rukminim1.flixcart.com/image/300/300/inflatable-sofa/6/j/s/wsb031a-velvet-wds-original-imaeaphzbkgrz3xp.jpeg?q=70",
    title: {
      shortTitle: "Inflatable Sofas",
    },
    discount: "Min 50% Off",
    tagline: "Furn Central & more",
  },
];
